"use client";

import { Typography } from "@kyan/ui";

import { LoadingGem } from "#/components/LoadingGem/LoadingGem";

export const ErrorState: React.FC = () => {
  return (
    <div className="border-divider absolute inset-0 grid place-items-center content-center gap-4 border-t bg-[radial-gradient(65.81%_88.28%_at_50.04%_49.9%,#FFF_18.4%,rgba(255,255,255,0.00)_100%)] backdrop-blur-xs dark:bg-[radial-gradient(71.34%_71.34%_at_48.37%_46.23%,rgba(0,0,0,0.80)_0%,rgba(0,0,0,0.00)_100%)]">
      <LoadingGem className="h-20" />
      <Typography element="p">
        Loading of the orderbook is taking longer than usual
      </Typography>
    </div>
  );
};
